import { useCallback, useContext, useEffect } from 'react';

import { getDate, getDateDifference, getCurrentDate } from '@libs/hooks';

import { useAuth } from 'src/hooks';
import { TOKEN_KEY } from 'src/constants';
import { RefreshTokenActionContext } from 'src/contexts';

const useRefreshTokenContext = () => useContext(RefreshTokenActionContext);

const TOKEN_REFRESH_THRESHOLD = 60 * 5; // 60 * 5 seconds = 5 min
export const useRefreshToken = () => {
  const { decodeToken } = useAuth();
  const { triggerRefreshToken } = useRefreshTokenContext();

  const handleRefreshToken = useCallback(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return;
    const decodedToken = decodeToken(token);
    if (!decodedToken) return;
    const expiration = decodedToken.exp;
    const now = getCurrentDate();

    // after -> token creation time + 5 min -> refresh token
    const tokenIssueWithTreshold = decodedToken.iat + TOKEN_REFRESH_THRESHOLD;
    const tokenIssueDate = getDate(tokenIssueWithTreshold * 1000);
    const dateDiffRelativeToIssueDate = getDateDifference(
      now,
      tokenIssueDate,
      'second'
    );
    if (dateDiffRelativeToIssueDate > 0) {
      triggerRefreshToken();
      return;
    }

    const expirationDate = getDate(expiration * 1000);
    const dateDiff = getDateDifference(expirationDate, now, 'second');
    if (dateDiff <= 0) {
      // TODO: navigate to session expiration modal
      return;
    }
  }, [triggerRefreshToken, decodeToken]);

  useEffect(() => {
    window.addEventListener('click', handleRefreshToken);

    return () => {
      window.removeEventListener('click', handleRefreshToken);
    };
  }, [handleRefreshToken]);
};
